import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageService } from '@services/helpers/message-service/message.service';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { _throw } from 'rxjs/observable/throw';
import { IntervalObservable } from 'rxjs/observable/IntervalObservable';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CalendarIntegrationProvider {
	googleActivationCode$: BehaviorSubject<string> = new BehaviorSubject(null);
	lookGoogleIntegration$: BehaviorSubject<string> = new BehaviorSubject(null);
	isIntegrated$: BehaviorSubject<boolean> = new BehaviorSubject(null);
	constructor(
		private http: HttpClient,
		private messageService: MessageService
	) {}

	calendarStatusTimer: boolean;

	get getGoogleActivationCode(): Observable<string> {
		return this.googleActivationCode$.asObservable();
	}

	setGoogleActivationCode(code: string | null): void {
		this.googleActivationCode$.next(code);
	}

	get getLookGoogleIntegration(): Observable<string> {
		return this.lookGoogleIntegration$.asObservable();
	}

	setLookGoogleIntegration(lookIntegration: string): void {
		this.lookGoogleIntegration$.next(lookIntegration);
	}

	get getIsIntegrated(): Observable<boolean> {
		return this.isIntegrated$.asObservable();
	}

	setIsIntegrated(isIntegrated: boolean | null): void {
		this.isIntegrated$.next(isIntegrated);
	}

	getActivatedCalendar(): Observable<any> {
		const url = '/api/user/v1/calendar/check';
		return this.http.get(url).pipe(catchError(err => this.handleError(err)));
	}

	synchronizeGoogleCalendar(): Observable<any> {
		const url = '/api/user/v1/calendar/synchronize';
		return this.http
			.post(url, {})
			.pipe(catchError(err => this.handleError(err)));
	}

	updateGoogleCalendarStatus(data): Observable<any> {
		const url = '/protected/rest/calendar/update';
		return this.http
			.post(url, {
				message: data
			})
			.pipe(catchError(err => this.handleError(err)));
	}

	connectGoogleCalendar(): Observable<any> {
		const url = '/protected/rest/calendar/';
		return this.http.get(url).pipe(catchError(err => this.handleError(err)));
	}

	disconnectGoogleCalendar(): Observable<any> {
		const url = '/api/user/calendar/disconnect/google';
		return this.http
			.request('delete', url)
			.pipe(catchError(err => this.handleError(err)));
	}

	calendarInterval() {
		const url = '/api/user/v1/calendar/check';
		return IntervalObservable.create(5000)
			.takeWhile(() => this.calendarStatusTimer)
			.flatMap(() => this.http.get(url))
			.switchMap(value =>
				Observable.of(value).map((result: any) => {
					if (result.data.state === 'NO_INTEGRATED') {
						throw new Error('Integration error');
					}
					return result;
				})
			)
			.catch(error => this.handleError(error));
	}

	stopCalendarInterval(): void {
		this.calendarStatusTimer = false;
	}

	startCalendarinterval(): void {
		this.calendarStatusTimer = true;
	}

	private handleError(error) {
		this.stopCalendarInterval();
		this.messageService.showDefaultErrorMessage(error);
		return _throw(error);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/services/calendar-integration/calendar-integration.service.ts